export const DEFAULT_ASSETS = {
  applicationName: 'Portal',
  imgSrcLogin: '/login.png',
  imgAltLogin:
    "Background image featuring the Ohio State seal, representing the university's central campus",
  imgSrcLogo: '/logo.png',
  imgAltLogo:
    'Logo of Clinical and Translational Science Institute at The Ohio State University'
}
